import { Component, OnDestroy, OnInit } from '@angular/core';
import { CategoryNavigationComponent, CmsComponentData, NavigationNode, NavigationService } from "@spartacus/storefront";
import { CmsNavigationComponent, CmsService } from "@spartacus/core";
import { GenNavigationService } from "../../../services/navigation.service"
import { Observable, Subscription } from 'rxjs';
import { Router } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { GenCustomerService } from 'src/app/generac/services/customer.service';

@Component({
  selector: 'gen-category-navigation',
  templateUrl: './category-navigation.component.html',
  standalone: false
})
export class GenCategoryNavigationComponent extends CategoryNavigationComponent implements OnInit, OnDestroy {
  override node$: Observable<NavigationNode> = this.genNavigationService.getNavigationNode(
    this.componentData.data$
  );
  private subscription = new Subscription();

  constructor(
    override componentData: CmsComponentData<CmsNavigationComponent>,
    override service: NavigationService,
    protected genNavigationService: GenNavigationService,
    protected customerService: GenCustomerService,
    protected cmsService: CmsService,
    private router: Router,
  ) {
    super(componentData, service);
  }

  ngOnInit(): void {
    this.subscribeToUnitChange();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToUnitChange() {
    this.subscription.add(
      this.customerService.getB2bUnitChanged()
        .pipe(
          filter(Boolean),
          map(() => this.router.routerState.snapshot.url?.split('/')?.filter(segment => !!segment)[0]),
          filter(url => url !== "product"),
        ).subscribe(() => this.cmsService.refreshLatestPage())
    );
  }
}
